import React from 'react';
import Form from '@grnhse/seedling/lib/birch/components/forms/form';
import type { MyGreenhouseProps } from 'talent_matching/types';
import MyGreenhousePageContent from 'talent_matching/my_greenhouse/my_greenhouse_page_content';
import noop from 'lodash/noop';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const MyGreenhouseDiscovery = (myGreenhouseProps: MyGreenhouseProps) => {
  const defaultValues = {};

  return (
    <Form defaultValues={defaultValues} onSubmit={noop} submitMode="preserve">
      <MyGreenhousePageContent />
    </Form>
  );
};

export default MyGreenhouseDiscovery;
